import React, { useState } from 'react';
import Nav from '../Page Components/Nav';
import Footer from "../Page Components/Footer";
import arrow from "../assets/Images/Arrow 2.png";
import phone from "../assets/Images/icons8-phone-48 2.png";
import location from "../assets/Images/pin 1.png";
import Title from "../Co Components/Titles";
import { useEffect } from 'react';
import axios from 'axios';
import PopupMessage from "../Co Components/PopupMessage";
import PopupCloseMessage from "../Co Components/PopupCloseMessage";
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
const Contact = () => {

     useEffect(() => {
        window.scrollTo(0, 0)


    },[]);
     useEffect(() => {
  setTimeout(() => {
    setShowPopup(false);
  }, 10000);
}, );
     const [showPopup, setShowPopup] = useState(false);
    const [success,setSuccess]=useState(false);
    const [error,setError]=useState(false);
    const handleButtonClick = () => {
        setShowPopup(true);
    };

    const handleCloseClick = () => {
        setShowPopup(false);

    };

    
    const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    axios.post('/contactus/details/', data,).then((response) => {
     if (response.status === 200) {
         // console.log('successful');
         setTimeout(() => {
        setSuccess(true);
        event.target.reset();
        setShowPopup(true);
      }, 500);
         // console.log(response.data);
         // Redirect to the home page after login
      }
    }).catch((error) => {
        if (error.response.status === 400) {
      // Display error message for invalid data entry

            setError(true);
            setShowPopup(true);
        } else {
      // Display generic error message
            setError(true);
         setShowPopup(true);
        }});
  };
    return (
        <>

            <Nav />
            <section className={' d-flex flex-col flex-wrap mt-16 justify-content-center'}>
                <article className={''}>
                    <div className={''}>
                        <center>
                            <Title header={"let's work"} body={"together"} />
                            <p className={'fs-6 Poppins  w-100'}>
                                Let us help you become even greater at what you do.
                                <br />
                                Fill out the following form and we will get back to you in the next 24 hours.

                            </p>
                        </center>
                    </div>
                </article>
            </section>

            <div className={'mt-15 mb-8'}>
                <div className={'d-flex flex-row contactDiv flex-wrap justify-content-around'}>
                    <div className={'formDiv'}>
                        <form method='post' onSubmit={handleSubmit}>
                            <div>
                                <h1 className={'bebas text-black d-inline mx-3'}>01</h1>
                                <label className={'h4 text-black'}>
                                    What's your name?
                                </label>
                                <input  placeholder={'Type full name'}
                                    name={'name'} className={'d-block inputContact bg-transparent mx-5'} type={'text'} />
                            </div>
                            <div>
                                <h1 className={'bebas text-black d-inline mx-3'}>02</h1>
                                <label className={'h4   text-black'}>
                                    What’s your e-mail address?
                                </label>
                                <input placeholder={'Type your email address'} name={'email'}
                     className={'d-block inputContact bg-transparent mx-5'} type={'email'} />
                            </div>
                            <div>
                                <h1 className={'bebas text-black d-inline mx-3'}>03</h1>
                                <label className={'h4   text-black'}>
                                    What’s your phone number?
                                </label>
                                <input placeholder={'+201234567890'} name={'phone'}
                     className={'d-block inputContact bg-transparent mx-5'} type={'phone'} />
                            </div>
                            <div>
                                <h1 className={'bebas text-black  d-inline mx-3'}>04</h1>
                                <label className={'h4   text-black'}>
                                    Tell us about your project
                                </label>
                                <input placeholder={'Describe your project'} name={'details'}
                     className={'d-block inputContact bg-transparent mx-5'} type={'text'} />
                            </div>
                            <button className={'secondary border-2'} type={'submit'}>Send Message <img className={'mx-2'} width={'20'} src={arrow} /></button>
                        </form>
                    </div>
                    <div className={'mt-10'}>
                        <div>
                            <h3 className={'bebas text-black'}>Call us</h3>
                            <p className={'text-black fs-6'}><img width={'25'} src={phone} />+44 1227391144</p>
                        </div>
                        <div>
                            <h3 className={'text-black bebas'}>ADDRESS</h3>
                            <p className={'text-black fs-6'}>
                                <img width={'10'} src={location} /> s 128, City Road,<br />
                                London, EC1V 2NX,<br />
                                UNITED KINGDOM
                            </p>
                        </div>
                    </div>
                </div>
                {(showPopup && success) && (
                    <PopupMessage onClose={handleCloseClick} text={"Your message has been sent successfully!"} />
      )}
                {(showPopup && error) &&
                    <PopupCloseMessage onClose={handleCloseClick} text={"Invalid data entry, Please try again!"} />
      }

            </div>
            <Footer />
        </>
    );

}

export default Contact;